export const setSubmenu = ({ commit }, ...args) => {
  commit('UPDATESUBMENU', ...args)
}



// WEBPACK FOOTER //
// ./src/store/actions/index.action.js